import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-list-bullet",
  templateUrl: "./med-icon-list-bullet.component.html",
})
export class MedIconListBulletComponent extends SvgMixinComponent {}
